import { DateTime } from "luxon"
import { date, object, string } from "yup"

const parseDateString = (value, originalValue) => {
  const parsedDate = originalValue ? new Date(originalValue) : null
  if (parsedDate instanceof Date && !isNaN(parsedDate)) {
    return DateTime.fromJSDate(parsedDate).startOf("day").toJSDate() // Normalize to start of the day
  }
  return null
}

export const orderStatisticsFilterSchema = object({
  from: date()
    .required("Start Date is required")
    .transform(parseDateString)
    .typeError("Invalid Start Date format. Expected format: MM/DD/YYYY")
    .max(
      DateTime.local().startOf("day").toJSDate(), // Max validation using Luxon
      "Start Date cannot be in the future. Please select a valid date."
    )
    .test(
      "start-before-end",
      "Start Date cannot be after End Date.",
      function (value) {
        const { to } = this.parent
        return !to || value <= to
      }
    ),
  to: date()
    .required("End Date is required")
    .transform(parseDateString)
    .typeError("Invalid End Date format. Expected format: MM/DD/YYYY")
    .max(
      DateTime.local().startOf("day").toJSDate(), // Max validation using Luxon
      "End Date cannot be in the future. Please select a valid date."
    )
    .test(
      "end-after-start",
      "End Date must be on or after Start Date.",
      function (value) {
        const { from } = this.parent
        return !from || value >= from
      }
    ),
  patientIssuer: string().label("Patient Issuer").required(),
})
